
















































































































































































































































import Vue from "vue"
import BaseMoney from "../../../base/components/BaseMoney.vue"
import BasePercent from "../../common/components/BasePercent.vue"
import InvestmentList from "../../investments/components/InvestmentList.vue"
import AutoInvestStrategyStatusButton from "../components/AutoInvestStrategyStatusButton.vue"

export default Vue.extend({
  name: "AutoInvestStrategyDetail",
  components: {
    InvestmentList,
    BasePercent,
    BaseMoney,
    AutoInvestStrategyStatusButton,
  },
  props: {
    id: { type: String, required: true },
  },
  data() {
    return {
      loading: true,
      loadingActivity: false,
      loadingInvestmentList: true,
      strategy: {},
      page: 1,
      size: 10,
      count: 0,
      investments: [],
      investor_interest_range: [1, 20],
      smsDialog: false,
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.page = 1
        this.fetch()
        this.fetchInvestments()
      },
    },
    page() { this.fetchInvestments(); this.$vuetify.goTo(this.$refs.investmentList) },
    size() { this.fetchInvestments() },
  },
  activated() { this.fetch(); this.fetchInvestments() },
  methods: {
    fetch() {
      this.loading = true
      this.$http
        .get(`/autoinvest_strategies/${this.id}/`)
        .then((response) => {
          this.loading = false
          this.strategy = response.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    fetchInvestments() {
      this.loadingInvestmentList = true
      this.$http
        .get(`/investments/?autoinvest_strategy=${this.id}&page=${this.page}&size=${this.size}`)
        .then((response) => {
          this.loadingInvestmentList = false
          this.count = response.data.count
          this.investments = response.data.results
        })
        .catch(() => {
          this.loadingInvestmentList = false
        })
    },
    updateStrategy(data) {
      Object.assign(this.strategy, data)
    },
  },
})
